import * as React from "react";
import { IStackTokens, Stack } from "@fluentui/react";
import { MetaItemsGroupsDirection } from "./MetaItemTypes";

export interface MetaItemGroupsLayoutProps {
  /**
   * The direction in which the groups will be displayed
   * @default horizontal
   */
  direction?: MetaItemsGroupsDirection;
  /**
   * Groups to be displayed
   */
  children: JSX.Element | JSX.Element[];
  /**
   * Space between groups in px
   */
  gap?: number;
  /**
   * Width of the LabelMetaItem label in px
   * @default 120
   */
  labelWidth?: number;
}

export const MetaItemsGroupsLayoutContext = React.createContext<{ labelWidth: number }>({} as { labelWidth: number });

export const MetaItemGroupsLayout = ({
  direction = MetaItemsGroupsDirection.Horizontal,
  children,
  gap = direction && direction === MetaItemsGroupsDirection.Horizontal ? 50 : 30,
  labelWidth = 120,
}: MetaItemGroupsLayoutProps): JSX.Element => {
  const childrenStackTokens: IStackTokens = { childrenGap: gap };
  const elements = Array.isArray(children) ? children : [children];
  const labelWidthValue = React.useMemo(() => (
    { labelWidth }
  ), [labelWidth]);

  const gapCount = elements.length - 1;
  const width = direction === MetaItemsGroupsDirection.Horizontal
    ? `calc(calc(100% - ${gap * gapCount}px) / ${elements.length})`
    : "auto";

  return (
    <MetaItemsGroupsLayoutContext.Provider value={labelWidthValue}>
      <Stack
        tokens={childrenStackTokens}
        horizontal={direction === MetaItemsGroupsDirection.Horizontal}
      >
        {elements.map((element, key) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`element-${key}`} style={{ width: `${width}` }}>
            {element}
          </div>
        ))}
      </Stack>
    </MetaItemsGroupsLayoutContext.Provider>
  );
};
